import React, { Component, Fragment } from "react";
import { Col, Form, Row, Table, Typography } from "antd";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";
import ModalshowAllImageBase64 from "../../../../../components/user/ModalshowAllImage/newsBase64";

class WelfareListPaymentVictimSecAttachment extends Component {
  state = {
    ModalshowAllImageVisible: false,
    ModalshowAllImageTitle: null,
    ModalshowAllImageData: [],
    ModalshowAllImageArrayId: null,
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "sort",
        align: "center",
        width: 100,
        render: (item, record, index) => index + 1,
      },
      {
        title: "เอกสาร",
        dataIndex: "documentTypeName",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "รายละเอียดเอกสาร",
        dataIndex: "description",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "เอกสารแนบ",
        dataIndex: "action",
        width: "200px",
        render: (item, record, index) =>
          this.showMoreFileUploadsAttach(index, record),
      },
    ],
  };

  showMoreFileUploadsAttach = (arrayId, uploadFile) => {
    if (uploadFile?.file) {
      return (
        <p
          onClick={() => {
            this.ModalshowAllImageShow(
              uploadFile,
              "เอกสารแนบ",
              arrayId,
              uploadFile
            );
          }}
          style={{ cursor: "pointer" }}
          className="mb-0 btn-show-fileuploads"
        >
          ดูไฟล์อัปโหลด
        </p>
      );
    }
  };

  ModalshowAllImageShow = async (data, title, arrayId, modalTypeUpload) => {
    let dataShowImage = [];
    dataShowImage.push(data.file);

    this.setState({
      ModalshowAllImageVisible: true,
      ModalshowAllImageTitle: title,
      ModalshowAllImageData: dataShowImage,
      ModalshowAllImageArrayId: arrayId,
    });
  };

  ModalshowAllImageHide = async () => {
    this.setState({
      ModalshowAllImageVisible: false,
      ModalshowAllImageTitle: null,
      ModalshowAllImageData: [],
      ModalshowAllImageArrayId: null,
    });
  };

  render() {
    const {
      ModalshowAllImageVisible,
      ModalshowAllImageTitle,
      ModalshowAllImageData,
      ModalshowAllImageArrayId,
      columns,
    } = this.state;
    const { rawData } = this.props;
    const welfareAttachment = rawData?.welfareAttachment || [];

    return (
      <Fragment>
        <ModalshowAllImageBase64
          title={ModalshowAllImageTitle}
          showModal={ModalshowAllImageVisible}
          data={ModalshowAllImageData}
          hideModal={this.ModalshowAllImageHide}
          dataArrayId={ModalshowAllImageArrayId}
          destroyArrayDataImages={this.destroyArrayDataImages}
          imageDatabase={false}
          // statusForm={statusForm}
        />
        <Row
          gutter={16}
          type="flex"
          justify="start"
          align="top"
          className="py-2"
        >
          <Col md={24} className="mb-3">
            <Typography.Text className="color-red" style={{ fontSize: "18px" }}>
              เอกสารแนบ
            </Typography.Text>
          </Col>
          <Col md={24}>
            <Table
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              columns={columns}
              dataSource={welfareAttachment}
              pagination={false}
              rowKey="id"
            />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

WelfareListPaymentVictimSecAttachment.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictimSecAttachment.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictimSecAttachment = Form.create()(
  WelfareListPaymentVictimSecAttachment
);

export default withApollo(WrappedWelfareListPaymentVictimSecAttachment);
